import { Theme } from '@material-ui/core';

export const muiButtonOverrides = (theme: Theme): Theme['overrides'] => ({
  MuiButton: {
    root: {
      borderRadius: 0,
      fontSize: 20,
      fontWeight: 400,
    },
    contained: {
      color: theme.palette.common.white,
    },
    containedPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    containedSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
    },
    outlined: {
      backgroundColor: 'white',
    },
    outlinedPrimary: {
      '&:hover': {
        backgroundColor: theme.palette.primary.light,
      },
    },
    outlinedSecondary: {
      '&:hover': {
        backgroundColor: theme.palette.secondary.light,
      },
    },
    sizeSmall: {
      fontSize: 16,
      lineHeight: '25px',
    },
    sizeLarge: {
      fontSize: 25,
      lineHeight: '40px',
    },
  },
});
